import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '@env/environment';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_SIGNIN_ONLY_ROLES',
    editProfile: 'B2C_1_profileediting1',
  },
  authorities: {
    signUpSignIn: {
      authority: environment.AadSignupSigninUrl,
    },
    editProfile: {
      authority: environment.AadEditprofileUrl,
    },
  },
  authorityDomain: environment.AadAuthorityDomain,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.AadClientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: `${window.location.origin}/authentication/callback`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      /*
       *loggerCallback: (logLevel, message, containsPii) => {
       *  console.log(logLevel, message, containsPii);
       *},
       */
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

export const protectedResources = {
  filterGruppe: {
    endpoint: `${environment.baseUrl}/Filtergruppe`,
    scopes: [environment.AadScope],
  },
  filter: {
    endpoint: `${environment.baseUrl}/Filter`,
    scopes: [environment.AadScope],
  },
  dokument: {
    endpoint: `${environment.baseUrl}/Dokument`,
    scopes: [environment.AadScope],
  },
  standort: {
    endpoint: `${environment.baseUrl}/Standort`,
    scopes: [environment.AadScope],
  },
  kfmaoCode: {
    endpoint: `${environment.baseUrl}/KfmaoCode`,
    scopes: [environment.AadScope],
  },
};
export const loginRequest = {
  scopes: [],
};
